'use client'
import React, { PropsWithChildren } from 'react'
import styles from './styles.module.scss'

interface CellProps extends PropsWithChildren {
  padding?: string
  align?: 'right' | 'center' | 'initial' | 'justify'
  className?: string
}

const Cell: React.FC<CellProps> = ({
  padding = '12px 16px',
  align = 'initial',
  className,
  ...props
}) => {
  return (
    <td
      {...props}
      style={{ padding, textAlign: align }}
      className={`${styles.cell} ${className ? className : ''}`}
    />
  )
}

export default Cell
